import React, { FC } from 'react';
import { MainImageContainer } from '../styled/containers/MainImageContainer';

const MainImage: FC = () => {
  return <MainImageContainer></MainImageContainer>;
};

export default MainImage;
